export const toJSON = (payload) => {
  return JSON.parse(JSON.stringify(payload));
};

